// extracted by mini-css-extract-plugin
export var sbShowMain = "image-module--sb-show-main--KV10i";
export var caption = "image-module--caption--1J8n0";
export var svgIcon = "image-module--svgIcon--cPu3S";